import { GSC_ADK_COACH_BASE_URL as buildTimeGscAdkCoachBaseUrl } from "virtual:gsc-adk-coach-base-url";

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");

const cleanEnvUrl = (value: string | undefined) => {
  const trimmed = value?.trim();
  return trimmed ? trimTrailingSlash(trimmed) : "";
};

const resolveBuildTimeCoachBaseUrl = () => cleanEnvUrl(buildTimeGscAdkCoachBaseUrl);

function resolveRequiredGscAdkCoachBaseUrl(errorMessage: string) {
  const baseUrl = resolveBuildTimeCoachBaseUrl();

  if (!baseUrl) {
    throw new Error(errorMessage);
  }

  return baseUrl;
}

export function resolveGscAdkCoachBaseUrl() {
  return resolveRequiredGscAdkCoachBaseUrl("GSC_ADK_COACH_BASE_URL is required for gsc-adk-coach requests.");
}

export function resolveCoachingRuntimeBaseUrl() {
  return resolveRequiredGscAdkCoachBaseUrl("GSC_ADK_COACH_BASE_URL is required for coaching turns.");
}

export function resolveCoachingTurnPath() {
  return "/turn";
}
